import React from 'react';
import { useBuild } from '../contexts/BuildContext';
import FarcasterItemsQuery from './queries/FarcasterItemsQuery';
import FarcasterUsersQuery from './queries/FarcasterUsersQuery';
import ZoraCoinsQuery from './queries/ZoraCoinsQuery';
import PolymarketItemsQuery from './queries/PolymarketItemsQuery';
import TokenItemsQuery from './queries/TokenItemsQuery';
import WalletUsersQuery from './queries/WalletUsersQuery';
import PolymarketWalletsQuery from './queries/PolymarketWalletsQuery';
import KalshiItemsQuery from './queries/KalshiItemsQuery';
import KalshiWalletsQuery from './queries/KalshiWalletsQuery';
import NotificationsQuery from './queries/NotificationsQuery';
import NotificationHyperliquidWalletsQuery from './queries/NotificationHyperliquidWalletsQuery';
import NotificationHyperliquidPositionsQuery from './queries/NotificationHyperliquidPositionsQuery';
import TradeEventsQuery from './queries/TradeEventsQuery';
import HyperliquidMarketsQuery from './queries/HyperliquidMarketsQuery';

const QueryColumn = () => {
  const { selectedIndex } = useBuild();
  switch (selectedIndex) {
    case 'farcaster-items':
      return <FarcasterItemsQuery />;
    case 'farcaster-users':
      return <FarcasterUsersQuery />;
    case 'zora-coins':
      return <ZoraCoinsQuery />;
    case 'polymarket-items':
      return <PolymarketItemsQuery />;
    case 'token-items':
      return <TokenItemsQuery />;
    case 'wallet-users':
      return <WalletUsersQuery />;
    case 'polymarket-wallets':
      return <PolymarketWalletsQuery />;
    case 'kalshi-items':
      return <KalshiItemsQuery />;
    case 'kalshi-wallets':
    case 'kalshi-wallets-v20260315':
      return <KalshiWalletsQuery />;
    case 'hyperliquid-wallets':
    case 'notification-hyperliquid-wallets':
      return <NotificationHyperliquidWalletsQuery />;
    case 'hyperliquid-wallet-positions':
    case 'notification-hyperliquid-wallet-positions':
      return <NotificationHyperliquidPositionsQuery />;
    case 'hyperliquid-items':
      return <HyperliquidMarketsQuery />;
    // Friendly chain-specific notification aliases (alpha-notifications-*)
    case 'hyperliquid-notifications':
    case 'polymarket-notifications':
    case 'dex-notifications':
      return <NotificationsQuery />;
    // Friendly chain-specific trade-event aliases (alpha-trade-events-*)
    case 'hyperliquid-trades':
    case 'polymarket-trades':
    case 'base-trades':
    case 'ethereum-trades':
    case 'solana-trades':
      return <TradeEventsQuery />;
    default:
      return null;
  }
};

export default QueryColumn;
